import { animations } from "./km/animations";
import { borderRadius } from "./km/borderRadius";
import { getColor } from "./km/color";
import { getElevation } from "./km/elevation";
import { spacing } from "./km/spacing";
import { typography } from "./km/typography";
import { getThemeUtil } from "./km/util";
import { legacyColors } from "./legacy/legacyColors";
import { legacyZIndex } from "./legacy/zindex";
/** Create a theme for a palette set. */ export function createTheme() {
    var session = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        themeName: "light"
    };
    return {
        name: session.themeName,
        session: session,
        km: {
            animations: animations,
            borderRadius: borderRadius,
            color: getColor(session.themeName),
            elevation: getElevation(session.themeName),
            spacing: spacing,
            typography: typography,
            util: getThemeUtil(session.themeName)
        },
        legacyColors: legacyColors,
        legacyZIndex: legacyZIndex
    };
}
